import BaseUIOrderQuickAddressView from 'xui/modules/order/BaseUIOrderQuickAddressView'

class OrderQuickAddressView extends BaseUIOrderQuickAddressView {
  static displayName = 'OrderQuickAddressView'
}

export default OrderQuickAddressView
